import React, { useState, useEffect } from 'react';
import { X, Cookie } from 'lucide-react';

const ConsentBanner: React.FC = () => {
  const [isVisible, setIsVisible] = useState(false);

  useEffect(() => {
    const consent = localStorage.getItem('cookie-consent');
    if (!consent) {
      setIsVisible(true);
    }
  }, []);

  const handleAccept = () => {
    localStorage.setItem('cookie-consent', 'accepted');
    setIsVisible(false);
  };

  const handleDecline = () => {
    localStorage.setItem('cookie-consent', 'declined');
    setIsVisible(false);
  };

  if (!isVisible) return null;

  return (
    <div className="fixed bottom-0 left-0 right-0 bg-white border-t border-gray-200 shadow-lg z-50">
      <div className="container-max px-4 py-4">
        <div className="flex flex-col md:flex-row items-start md:items-center justify-between space-y-4 md:space-y-0 md:space-x-4 rtl:md:space-x-reverse">
          <div className="flex items-start space-x-3 rtl:space-x-reverse">
            <Cookie className="w-6 h-6 text-primary-600 mt-1 flex-shrink-0" />
            <div>
              <p className="text-sm text-gray-700">
                We use cookies to enhance your experience and analyze our traffic. 
                By continuing to use our site, you consent to our use of cookies.
              </p>
            </div>
          </div>
          
          <div className="flex items-center space-x-3 rtl:space-x-reverse">
            <button
              onClick={handleDecline}
              className="text-sm text-gray-500 hover:text-gray-700 transition-colors"
            >
              Decline
            </button>
            <button
              onClick={handleAccept}
              className="btn-primary text-sm"
            >
              Accept
            </button>
            <button
              onClick={handleDecline}
              className="p-1 text-gray-400 hover:text-gray-600 transition-colors"
            >
              <X className="w-5 h-5" />
            </button>
          </div>
        </div>
      </div>
    </div>
  );
};

export default ConsentBanner;
